import { ReactNode, useEffect, useState } from 'react';
import axios, { AxiosError, AxiosResponse } from 'axios';

import { api } from '@hooks/useFetch';

import { handleRedirect, ResponseStatusAction } from "@core/responseHandlers";

const AxiosInterceptor = ({ children }: { children: ReactNode }) => {
    const [isSet, setIsSet] = useState(false);

    const onResponse = (response: AxiosResponse): AxiosResponse => {

        return response;
    };

    const onErrorResponse = (error: AxiosError): Promise<AxiosError> => {
        if (axios.isAxiosError(error)) {
            const { status } = (error.response as AxiosResponse) ?? {};

            if (status === 401) {
                handleRedirect(ResponseStatusAction.RedirectAuth);
            }

            if (status === 403) {
                handleRedirect(ResponseStatusAction.RedirectSnap);
            }

            if (status === 415) {
                return Promise.resolve(error);
            }
        }
        return Promise.reject(error);
    };

    useEffect(() => {
        const responseInterceptor = api.interceptors.response.use(onResponse, onErrorResponse);
        setIsSet(true);

        return () => api.interceptors.response.eject(responseInterceptor);
    }, []);

    return <>{isSet && children}</>;
};

export default AxiosInterceptor;
